import * as React from 'react';
import { SearchResultItem } from '../../components/SearchResultItem';
import { TBuilders } from '../../types/redux/state';

export interface ISearchResultItemContainerProps {
  builder: TBuilders[0];
}

export function SearchResultItemContainer({ builder }: ISearchResultItemContainerProps): React.JSX.Element {
  const {
    name,
    founded,
    logoUrl,
    totalBuildingCount,
    totalOfferCount,
    totalBuiltCount,
    totalBuildingUrl,
    totalBuiltUrl,
    url,
    totalOffersUrl,
  } = builder;

  return (
    <SearchResultItem
      name={name}
      founded={founded ?? undefined}
      logoUrl={logoUrl ?? ''}
      totalBuildingCount={totalBuildingCount}
      totalBuiltCount={totalBuiltCount}
      totalOffersCount={totalOfferCount}
      totalBuildingUrl={totalBuildingUrl ?? undefined}
      totalBuiltUrl={totalBuiltUrl ?? undefined}
      builderUrl={url}
      totalOffersUrl={totalOffersUrl ?? undefined}
    />
  );
}
